import { FeeType } from 'types/graphql'

import { OrgSlugs } from 'src/constants'

const hideCashSlugs = [OrgSlugs.StGeorge]

export const isCashSupported = (slug: OrgSlugs): boolean => {
  return !hideCashSlugs.includes(slug)
}

export const LateFeeTypes: FeeType[] = ['Late'] as const
